import { useState, useCallback, useRef, useEffect } from "react";

export function useCopyToClipboard() {
    const [copiedField, setCopiedField] = useState<string | null>(null);
    const timeoutRef = useRef<number | null>(null);

    useEffect(() => {
        return () => {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleCopyToClipboard = useCallback(async (fieldIdOrValue: string, value?: string) => {
        const text = value ?? fieldIdOrValue;
        const fieldId = value ? fieldIdOrValue : "";

        try {
            await navigator.clipboard.writeText(text);
            setCopiedField(fieldId);
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = window.setTimeout(() => setCopiedField(null), 2000);
        } catch (err) {
            console.error("Failed to copy to clipboard:", err);
        }
    }, []);

    const copied = copiedField !== null;

    return { copiedField, handleCopyToClipboard, copied };
}
